/* eslint-disable react/no-danger */
import React from 'react';
import { ReactComponent as ContactImg } from 'Assets/svg/contact-img.svg';
import { ReactComponent as UpgradeContactImg } from 'Assets/svg/upgrade-img.svg';
import { ReactComponent as CloseIcon } from 'Assets/svg/close-material.svg';
import Utils from 'Utils/utils';

const paidUserMessages = {
  image: ContactImg,
  title: 'Contact Us',
  message:
    '<p class="enable-content">Your current plan does not support job change alerts.</p><p class="enable-content">Contact us at <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a> to upgrade your plan <br /> and start enjoying the benefit of updated contacts.</p>',
};

const freeUserMessages = {
  image: UpgradeContactImg,
  title: 'Upgrade your plan!',
  message:
    '<p class=\'enable-content upgrade-content\' >We have noticed some of your contacts have changed their<br/> jobs. Upgrade your plan by contacting <a href="mailto:support@adapt.io" target="_blank">support@adapt.io</a> <br/> to receive those updates.</p>',
};

const EnablePopUp = ({ jobChangePopUp, popUpFunction }) => {
  const enablePopUp = jobChangePopUp;
  const messagesToShow = Utils.isLBPaidSubscription()
    ? paidUserMessages
    : freeUserMessages;

  const { image: Image, title, message } = messagesToShow;
  return (
    <div>
      {enablePopUp === true && (
        <>
          <div className="common-popup">
            <div className="popup-wrap">
              <div className="enable-popup">
                <Image />
                <CloseIcon
                  className="enable-close-icon"
                  onClick={popUpFunction}
                />
                <span>{title}</span>
                <div dangerouslySetInnerHTML={{ __html: message }} />
                <button
                  className="green-button"
                  type="button"
                  onClick={popUpFunction}
                >
                  OK
                </button>
              </div>
            </div>
          </div>
          <div
            className="common-popup-mask common-back-ground"
            onClick={popUpFunction}
          />
        </>
      )}
    </div>
  );
};
export default EnablePopUp;
